<script>
    import {createEventDispatcher} from "svelte";
    const dispatch = createEventDispatcher();

    export let opened = false;
    export let sections = [];

    function scrollToSection (id) {
        dispatch('scrollToSection', {id});
    }
</script>

<style>
    .sections-container {
        overflow: hidden;
    }
    .sections-block {
        font-size: var(--fs-120);
        font-weight: 400;
        width: 100vw;
        height: 0;
    }
    .sections-block--opened {
        height: unset;
    }
    ul {
        align-items: center;
        overflow-y: scroll;
        padding: 0 1.25rem .5rem 1.25rem;
    }
    li {
        white-space: nowrap;
        padding: 0.75rem 0;
        border: 1px solid transparent;
        cursor: pointer;
    }
    li+li {
        border-top: 1px solid var(--list-items-separator);
    }
</style>

<div class="sections-container">
    <div class="sections-block {opened ? 'sections-block--opened' : ''}">

        <ul>
            {#each sections as section}
                {#if (section?.title !== undefined && section?.title !== '')}
                <li class="user-select-none pointer" on:click={() => scrollToSection(section.id)}>
                    { section.title }
                </li>
                {/if}
            {/each}
        </ul>

    </div>
</div>
